module.exports = __webpack_public_path__ + "img/symbols_download.0391b402.svg";